import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { CancelOrderReasonAdminMiniDto } from '@/backend/market'
import { CancelOrderReasonMiniEntity } from '../../domain/entities/CancelOrderReasonMiniEntity'

export class CancelOrderReasonMiniModel extends CancelOrderReasonMiniEntity {
  constructor(dataDto: CancelOrderReasonAdminMiniDto) {
    super()
    mapEntityProperties<CancelOrderReasonMiniEntity>(this, dataDto)
  }
}
